import React, { Component, useState, useEffect } from "react";
import HomeViewStyles from "../styles";
import { ModalContext } from "../App.js";
import { fetchAllRoadmaps } from "../stitch";

import { Link } from "react-router-dom";

const HomeView = (props) => {
  const [viewMode, setViewMode] = useState("featured");
  const [roadmapData, setRoadmapData] = useState([]);
  useEffect(() => {
    fetchAllRoadmaps().then((allroadmaps) => {
      setRoadmapData(allroadmaps);
    });
  }, []);
  const HomeViewNav = () => {
    return (
      <div className="HomeViewNavContainer">
        <div
          onClick={() => {
            setViewMode("featured");
          }}
          className="HomeViewNavItem"
        >
          Featured
        </div>
        <div
          onClick={() => {
            setViewMode("browse");
          }}
          className="HomeViewNavItem"
        >
          Browse
        </div>
        <div
          onClick={() => {
            setViewMode("earnest");
          }}
          className="HomeViewNavItem"
        >
          Development Notes
        </div>
      </div>
    );
  };

  const ModalToggler = (props) => {
    return (
      <ModalContext.Consumer>
        {({ isModalShowing, toggleModal }) => (
          <div
            onClick={() => {
              if (isModalShowing) {
                toggleModal();
              }
            }}
          >
            {props.children}
          </div>
        )}
      </ModalContext.Consumer>
    );
  };
  switch (viewMode) {
    case "featured":
      return (
        <ModalToggler>
          <HomeViewNav />

          <div style={{ color: "red" }}></div>
          {roadmapData.map((d) => (
            <RoadmapCard data={d} />
          ))}
        </ModalToggler>
      );
    case "browse":
      return (
        <ModalToggler>
          <HomeViewNav />
          <div>browse view</div>
        </ModalToggler>
      );
    case "earnest":
      return (
        <ModalToggler>
          <HomeViewNav />
          <div style={{ width: "90%", margin: "1rem auto" }}>
            <div>Notes: </div>
            <ol>
              <li>
                1) I need to configure some AWS stuff for Stitch => Realm
                migration, Creator is functional except publishing it will
                return some s3 errors
              </li>
              <li>
                2) One Click log in as a global test user, go to dashboard to
                play with the tracked roadmap
              </li>
              <li>
                3) This site is barebone, visit
                <a href="https://github.com/BlastWind/roadmapedia">
                  The project github
                </a>
                for development status
              </li>
            </ol>
          </div>
        </ModalToggler>
      );
    default:
      return <></>;
  }
};
export default HomeView;

const RoadmapCard = ({ data }) => {
  const { roadmapDataHistory, customThumbnail, _id, percentage } = data;
  const { title, description, backgroundColor } = roadmapDataHistory[
    roadmapDataHistory.length - 1
  ];
  const pushToLink = `/roadmap/${_id}`;
  return (
    <React.Fragment>
      <div className="roadmapContainer">
        <img
          src={"https://roadmapedia.s3.amazonaws.com/" + customThumbnail.url}
          className="roadmapImg"
          style={{
            backgroundColor:
              customThumbnail.type === "default" ? backgroundColor : null,
          }}
        />
        <div className="metaContainer">
          <div className="metaContainer-inner">
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to={{ pathname: pushToLink, state: { mode: "draft" } }}
            >
              <div className="roadmapTitle">
                <div>{title}</div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
